import BrandCards from './BrandCards';

const BrandsGrid = ({
    brandImages,
    menuSlug,
    atts,
    rootId,
    isMenuPage,
    setSelectedFilters,
}) => {
    const title = atts?.title ?? null;
    const slider = atts?.slider ?? true;
    const sectionClassName = `headless-menu-builder-section ${isMenuPage ? 'headless-menu-brand-cards' : ''
        }`;

    // filter which images to make cards from.
    const images = Object.fromEntries(
        Object.entries(brandImages).filter(([key, _]) =>
            atts.menuFilter.brandSlider.includes(key)
        )
    );
    
    const sliderBreakpoints = {
        'breakpoint_sm': atts.breakpoint_sm ?? 1,
        'breakpoint_md': atts.breakpoint_md ?? 2,
        'breakpoint_lg': atts.breakpoint_lg ?? 3,
        'breakpoint_xl': atts.breakpoint_xl ?? 5,
        'breakpoint_xxl': atts.breakpoint_xxl ?? 6
    };

    return (
        <div className={sectionClassName}>
            {title && (
                <div className='headless-menu-builder-title'>
                    <div className='headless-shortcode-title-wrapper'>
                        <div className='headless-shortcode-title'>
                            <span
                                dangerouslySetInnerHTML={{ __html: title }}
                                suppressHydrationWarning={true}
                            ></span>
                            <noscript>
                                <span>{title}</span>
                            </noscript>
                        </div>
                    </div>
                </div>
            )}
            {Object.keys(brandImages).length > 0 ? (
                <BrandCards
                    slider={slider}
                    brandImages={images}
                    menuSlug={menuSlug}
                    isMenuPage={isMenuPage}
                    rootId={rootId}
                    setSelectedFilters={setSelectedFilters}
                    sliderBreakpoints={sliderBreakpoints}
                />
            ) : null}
        </div>
    );
};

export default BrandsGrid;
